import React from "react";
import { Navbar, Container, Button } from "react-bootstrap";
import { removeAuthToken } from "../../utils/auth";
import ThemeToggle from "../common/ThemeToggle";

function Topbar() {

    const handleLogout = () => {
        removeAuthToken()
        window.location.href = "/login";
    };

    return (
        <Navbar className="shadow-sm bg-body-tertiary">
            <Container fluid>
                <Navbar.Brand>Admin Dashboard</Navbar.Brand>
                <div className="d-flex align-items-center gap-2">
                    <ThemeToggle variant="outline-secondary" />
                    <Button variant="outline-danger" onClick={handleLogout}>
                        Logout
                    </Button>
                </div>
            </Container>
        </Navbar>
    );
}

export default Topbar;
